import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyDTSxgL4oyXBJ1rpdJxQl-ygJ3l-X7N2WA",
    authDomain: "movement-control.firebaseapp.com",
    databaseURL: "https://movement-control.firebaseio.com",
    projectId: "movement-control",
    storageBucket: "movement-control.appspot.com",
    messagingSenderId: "664362395452",
    appId: "1:664362395452:web:93ed44f9d78d978d942039",
    measurementId: "G-ZD6MZ4HYEB"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();

export const auth = firebase.auth();
export const firestore = firebase.firestore();